export enum PublicPaths {
  unsubscribe = 'unsubscribe/:signature',
}
